import BrButton from '@govbr/react-components/lib/BrButton';
import { Checkbox } from '@material-ui/core';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import imgMoca1 from '../../../assets/img/como-cadastrar-moca1.svg';
import imgMoca2 from '../../../assets/img/como-cadastrar-moca3.svg';
import imgPagina2 from '../../../assets/img/como-cadastrar-pagina4.svg';
import imgPagina1 from '../../../assets/img/tutorial-pre-cadastro-pagina1.svg';
import { selectGovBr } from '../../../auth/authSlice';
import styles from './TutorialConsultaRenda.module.css';

const TutorialConsultaRenda: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  const govBrLogado = useAppSelector(selectGovBr).logado;

  const [page, setPage] = useState(1);
  const [isNaoExibirNovamente, setIsNaoExibirNovamente] = useState(false);

  const handleOnChangeNaoExibirNovamente = () => {
    setIsNaoExibirNovamente(!isNaoExibirNovamente);
  };

  const concluir = () => {
    if (isNaoExibirNovamente) {
      localStorage.setItem('cadunico/tutorial-consulta-renda-nao-exibir', 'true');
    }

    if (location.state?.readOnly) {
      // Se o usuário estiver abrindo o tutorial somente leitura, não redireciona para consulta
      // de renda.
      return history.goBack();
    }

    // Execução padrão de redirecionar para a tela de consulta de renda.
    if (!govBrLogado) {
      localStorage.setItem('cadunico/redirect', '/consultaRenda');
    }
    history.replace('/consultaRenda');
  };

  const pagina1 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Consulta da renda identificada no CNIS </div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.text} ${styles.small}`}>
            O Governo Federal passou a utilizar as informações do Cadastro Nacional de Informações Sociais (CNIS) para atualização das informações do Cadastro Único. 
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Com isso, você pode consultar informações de renda (ganhos ou salário) do seu trabalho ou benefícios pagos a você pelo INSS nos últimos 12 meses. 
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Tudo isso, direto aqui, no seu aplicativo do Cadastro Único e com informações atualizadas todo mês. 
          </div>

          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(2)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div
                onClick={() => setPage(1)}
                className={`${styles.bulletPoint} ${styles.selecionado}`}
              ></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina1} src={imgPagina1} alt="Imagem do rodapé" />
          <img className={styles.imgMoca1} src={imgMoca1} alt="Mulher em pé" />
        </div>
      </div>
    </div>
  );

  const pagina2 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>
            Renda atualizada automaticamente pelo Governo Federal
          </div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.text} ${styles.small}`}>
            Nessa opção, você pode ver as rendas que o Governo Federal atualizou de forma automática no seu Cadastro Único. Isso significa que o seu cadastro não foi alterado pelo Responsável Familiar ou pelo município, e sim, pelo Governo Federal. 
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            São rendas de seu trabalho ou benefícios pagos pelo INSS identificadas no CNIS nos últimos 12 meses e incluídas no seu Cadastro Único. 
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Se você não teve nenhuma renda atualizada pelo Governo Federal, essa opção "Renda atualizada automaticamente pelo Governo Federal" não será exibida. 
          </div>
          <div className={styles.footerWrapper}>
            <div
              className={styles.checkboxWrapper}
              style={location.state?.readOnly ? { display: 'none' } : {}}
            >
              <Checkbox
                color="primary"
                onChange={handleOnChangeNaoExibirNovamente}
                checked={isNaoExibirNovamente}
                className={styles.checkbox}
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
              <span className={styles.checkboxText} onClick={handleOnChangeNaoExibirNovamente}>
                Não exibir novamente
              </span>
            </div>
            <div className={styles.botaoWrapper}>
              <BrButton className={styles.botao} onClick={() => concluir()}>
                Concluir
              </BrButton>
              <div className={styles.bulletPointWrapper}>
                <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
                <div
                  onClick={() => setPage(2)}
                  className={`${styles.bulletPoint} ${styles.selecionado}`}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina2} src={imgPagina2} alt="Imagem do rodapé" />
          <img className={styles.imgMoca2} src={imgMoca2} alt="Mulher sentada" />
        </div>
      </div>
    </div>
  );

  return (
    <>
      {page === 1 && pagina1}
      {page === 2 && pagina2}
    </>
  );
};

export default TutorialConsultaRenda;
